const state = {

    stateReq: null,
    stateRes: null,


}

// getters
const getters = {

    GET_STATE_REQ: (state) => {
        return state.stateReq;
    },
    GET_STATE_RES: (state) => {
        return state.stateRes;
    },

}

// actions
const actions = {
    CLEAR_STATE_LIST_STORE({ commit }) {
        commit("clearStatelsStore");
    },
    SET_STATE_REQ({ commit }, req) {
        commit('getStateReq', req);
    },
    SET_STATE_RES({ commit }, res) {
        commit('getStateRes', res);
    },

}

// mutations
const mutations = {
    clearStatelsStore(state) {
        state.stateReq = null;
        state.stateRes = null;
    },
    getStateReq(state, req) {
        state.stateReq = req
    },
    getStateRes(state, res) {
        state.stateRes = res
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}